import {escapedTemplate} from '../../../utils/escapeHtml.js'
import {welcomeTemplate} from './customerWelcomeTemplate.js'

// Same mail as for customers: the message, the login name and a button to create a password
export default escapedTemplate(welcomeTemplate)
